// Layout Header Styles
export const layoutHeaderClasses = [
  "t2-layout__header",
  "text-gray-m9",
  "text-[2.5rem]",
  "font-light",
  "tracking-[0.8px]",
  "leading-[3rem]",
  "m-0",
  "mb-[30px]",
  "max-sm:text-[1.625rem]",
  "max-sm:leading-[2rem]",
  "max-sm:tracking-[0.52px]",
  "t2-dark:text-white",
  "text-balance",
  "max-sm:break-words",
  "max-sm:hyphens-auto",
].join(" ")
// Layout Big Header Styles
export const layoutHeaderBigClasses = [
  "border-l-[10px]",
  "border-solid",
  "border-l-yellow-m10",
  "!pl-5",
  "mt-2.5",
  "mb-[30px]",
  "text-black",
  "text-[4rem]",
  "font-extrabold",
  "leading-[4rem]",
  "tracking-[-2px]",
  "sm:text-[80px]",
  "sm:text-gray-m9",
  "sm:leading-[96px]",
  "sm:tracking-[-4px]",
  "t2-dark:text-white",
  "text-balance",
  "max-sm:break-words",
  "max-sm:hyphens-auto",
].join(" ")
export const layoutSubheaderClasses = [
  "mb-2",
  "max-w-2xl",
  "text-2xl",
  "font-bold",
  "leading-8",
  "tracking-normal",
  "text-gray-m9",
  "t2-dark:text-white",
].join(" ")
export const layoutEyebrowClasses = "t2-layout__eyebrow"
export const layoutDescriptionClasses = [].join(" ")

// HeroLead Header Styles (larger sizing than standard layout headers)
export const heroLeadHeaderClasses = [
  "text-gray-m9",
  "text-[2.5rem]",
  "leading-[3rem]",
  "tracking-[0.8px]",
  "font-light",
  "mb-[30px]",
  "min-[960px]:text-[4.75rem]",
  "min-[960px]:leading-[5rem]",
  "min-[960px]:tracking-[0.76px]",
  "min-[960px]:mb-8",
  "t2-dark:text-white",
  "text-balance",
  "max-sm:break-words",
  "max-sm:hyphens-auto",
].join(" ")
